import React from 'react';
import { CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface Props {
  color?: 'primary' | 'secondary' | 'inherit';
  disableShrink?: boolean;
  size?: number | string;
}

const Loader: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <CircularProgress {...props} />
    </div>
  );
};

export default Loader;
